import React from 'react';
import { Stack, Typography } from '@mui/material';

export const SimpleView = props => {
  const { data } = props;

  return (
    <Stack direction="column" spacing={1} padding={2}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3}>
        <Typography >Imię i nazwisko: </Typography>
        <Typography color="primary"><b>{data.name}</b></Typography>
      </Stack>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3}>
        <Typography >Nr. telefonu: </Typography>
        <Typography color="primary"><b>{data.phone}</b></Typography>
      </Stack>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3}>
        <Typography >Data urodzenia: </Typography>
        <Typography color="primary"><b>{data.birth_date}</b></Typography>
      </Stack>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3}>
        <Typography >Płeć: </Typography>
        <Typography color="primary"><b>{data.gender === 'boy' ? 'Chłopiec' : data.gender === 'girl' ? 'Dziewczynka' : ''}</b></Typography>
      </Stack>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3}>
        <Typography >Miasto: </Typography>
        <Typography color="primary"><b>{data.city}</b></Typography>
      </Stack>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3}>
        <Typography >Kod pocztowy: </Typography>
        <Typography color="primary"><b>{data.postal_code}</b></Typography>
      </Stack>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3}>
        <Typography >Adres: </Typography>
        <Typography color="primary"><b>{data.street_address}</b></Typography>
      </Stack>
    </Stack>
  );
};
